"use strict"

import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

export default function GenerateDropdown({ title, id, list, onClickFunc }) {
  return (
    <DropdownButton variant={"outline-primary"} title={title} id={id} size={"sm"}>
      {(list || []).map((val, idx) => (
        <Dropdown.Item key={idx} name={val} onClick={(e) => onClickFunc(e, val)}>
          <h6 className={"text-center"}>{val}</h6>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}
